import { Component, input, output, computed } from '@angular/core'

import { DialogModule } from 'primeng/dialog'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { ProductSizeGuide, SizeGuideSize, GuideGroup } from 'app/_shared/interfaces/Product'

@Component({
  selector: 'app-size-guide-dialog',
  standalone: true,
  imports: [DialogModule, ButtonComponent],
  templateUrl: './size-guide-dialog.component.html',
  styleUrl: './size-guide-dialog.component.scss'
})
export class SizeGuideDialogComponent {
  visible = false
  visibleChange = output<boolean>()
  sizeGuides = input<ProductSizeGuide[]>([])

  open(): void {
    this.visible = true
    this.visibleChange.emit(this.visible)
  }

  close(): void {
    this.visible = false
    this.visibleChange.emit(this.visible)
  }

  readonly groups = computed<GuideGroup[]>(() =>
    SizeGuideDialogComponent.buildGroups(this.sizeGuides())
  )

  findValue(list: SizeGuideSize[], size: string): string | null {
    return list.find(s => s.size === size)?.value ?? null
  }

  private static buildGroups(guides: ProductSizeGuide[]): GuideGroup[] {
    if (!guides?.length) return []

    const sortSizes = (a: string, b: string): number => {
      const order = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL']
      const ai = order.indexOf(a)
      const bi = order.indexOf(b)
      if (ai !== -1 && bi !== -1) return ai - bi
      if (ai !== -1) return -1
      if (bi !== -1) return 1
      return a.localeCompare(b)
    }

    const keyOf = (sizes: string[]) => [...new Set(sizes)].sort(sortSizes).join('|')

    const freq = new Map<string, number>()
    guides.forEach(g => {
      const key = keyOf(g.size_guide_sizes.map(s => s.size))
      freq.set(key, (freq.get(key) ?? 0) + 1)
    })
    const [mainKey] = [...freq.entries()].sort((a, b) => b[1] - a[1])[0]
    const mainSizes = mainKey.split('|')

    const groups: GuideGroup[] = [{ sizes: mainSizes, specs: [] }]

    guides.forEach(spec => {
      const sizes = spec.size_guide_sizes.map(s => s.size)
      const fitsMain = sizes.every(s => mainSizes.includes(s))
      if (fitsMain) {
        groups[0].specs.push(spec)
        return
      }

      const key = keyOf(sizes)
      let group = groups.find(g => keyOf(g.sizes) === key)
      if (!group) {
        group = { sizes: [...sizes].sort(sortSizes), specs: [] }
        groups.push(group)
      }
      group.specs.push(spec)
    })

    return groups
  }
}
